var map = {
	"./": 323,
	"./banner/banner-breadcrumb": 862,
	"./banner/banner-breadcrumb.js": 862,
	"./banner/styles.module.scss": 863,
	"./brands/brand-info": 864,
	"./brands/brand-info.js": 864,
	"./brands/brand-list": 311,
	"./brands/brand-list.js": 311,
	"./brands/brand-list.js.bak": 2127,
	"./brands/styles.module.scss": 445,
	"./brands/vip-gift.module.scss": 865,
	"./catalogues/catalogue-info": 866,
	"./catalogues/catalogue-info-pos": 477,
	"./catalogues/catalogue-info-pos.js": 477,
	"./catalogues/catalogue-info.js": 866,
	"./catalogues/catalogue-info.module.scss": 883,
	"./catalogues/catalogue-list": 459,
	"./catalogues/catalogue-list.js": 459,
	"./catalogues/catalogue-pos": 884,
	"./catalogues/catalogue-pos.js": 884,
	"./catalogues/styles.module.scss": 200,
	"./cibc/cibc-calculation": 885,
	"./cibc/cibc-calculation.js": 885,
	"./cibc/cibc-contact-us": 464,
	"./cibc/cibc-contact-us.js": 464,
	"./cibc/cibc-recruit": 462,
	"./cibc/cibc-recruit.js": 462,
	"./cibc/cibc-servicepoint": 465,
	"./cibc/cibc-servicepoint.js": 465,
	"./cibc/cibc.css": 886,
	"./cibc/styles.module.scss": 240,
	"./customer-service/contact-us": 887,
	"./customer-service/contact-us.js": 887,
	"./customer-service/contact-us.module.scss": 888,
	"./customer-service/faq-us": 463,
	"./customer-service/faq-us.js": 463,
	"./customer-service/feedback": 466,
	"./customer-service/feedback.js": 466,
	"./customer-service/queryOptions": 319,
	"./customer-service/queryOptions.json": 319,
	"./customer-service/queryOptionsDev": 467,
	"./customer-service/queryOptionsDev.json": 467,
	"./customer-service/querySubjectOptions": 321,
	"./customer-service/querySubjectOptions.json": 321,
	"./customer-service/queryTargetOptions": 320,
	"./customer-service/queryTargetOptions copy": 889,
	"./customer-service/queryTargetOptions copy.json": 889,
	"./customer-service/queryTargetOptions.json": 320,
	"./customer-service/retailChannelOptions": 322,
	"./customer-service/retailChannelOptions.json": 322,
	"./customer-service/service-us": 890,
	"./customer-service/service-us.js": 890,
	"./customer-service/styles.module.scss": 241,
	"./editor.scss": 2175,
	"./index": 323,
	"./index.js": 323,
	"./member/member-cobrandedcard": 891,
	"./member/member-cobrandedcard.js": 891,
	"./member/member-hkcard": 892,
	"./member/member-hkcard.js": 892,
	"./news/news-info": 893,
	"./news/news-info.js": 893,
	"./news/news-list": 894,
	"./news/news-list-preview": 895,
	"./news/news-list-preview.js": 895,
	"./news/news-list.js": 894,
	"./news/styles.module.scss": 326,
	"./recipes/recipe-info": 896,
	"./recipes/recipe-info.js": 896,
	"./recipes/recipe-list": 897,
	"./recipes/recipe-list.js": 897,
	"./recipes/styles.module.scss": 479,
	"./repair/repair-info": 898,
	"./repair/repair-info.js": 898,
	"./repair/styles.module.scss": 899,
	"./stock/stock-all": 470,
	"./stock/stock-all.js": 470,
	"./stock/stock-list": 468,
	"./stock/stock-list.js": 468,
	"./stock/stock-store": 900,
	"./stock/stock-store.js": 900,
	"./stock/styles.module.scss": 469,
	"./stores/store-info": 902,
	"./stores/store-info.js": 902,
	"./stores/store-list": 903,
	"./stores/store-list-v2": 443,
	"./stores/store-list-v2.js": 443,
	"./stores/store-list.js": 903,
	"./stores/store-list.js.bak": 904,
	"./stores/store-list.js.bak.mjs": 904,
	"./stores/store-map": 444,
	"./stores/store-map.js": 444,
	"./stores/store-vendor": 905,
	"./stores/store-vendor.js": 905,
	"./stores/styles.module.scss": 130,
	"./style.scss": 2179,
	"./users/styles.module.scss": 156,
	"./users/user-big-platform-process": 457,
	"./users/user-big-platform-process.js": 457,
	"./users/user-carrier-binding": 458,
	"./users/user-carrier-binding.js": 458,
	"./users/user-connect": 456,
	"./users/user-connect.js": 456,
	"./users/user-invoice": 454,
	"./users/user-invoice-carrier-consolidation": 455,
	"./users/user-invoice-carrier-consolidation.js": 455,
	"./users/user-invoice.js": 454,
	"./users/user-loyaltyprofile": 906,
	"./users/user-loyaltyprofile.js": 906,
	"./users/user-password": 450,
	"./users/user-password-cc": 451,
	"./users/user-password-cc.js": 451,
	"./users/user-password-oca": 907,
	"./users/user-password-oca.js": 907,
	"./users/user-password.js": 450,
	"./users/user-payment": 452,
	"./users/user-payment-oca": 908,
	"./users/user-payment-oca.js": 908,
	"./users/user-payment.js": 452,
	"./users/user-point": 453,
	"./users/user-point.js": 453,
	"./users/user-profile": 448,
	"./users/user-profile-cc": 449,
	"./users/user-profile-cc.js": 449,
	"./users/user-profile-oca": 909,
	"./users/user-profile-oca.js": 909,
	"./users/user-profile.js": 448,
	"./users/user-sso-login": 446,
	"./users/user-sso-login-cc": 447,
	"./users/user-sso-login-cc.js": 447,
	"./users/user-sso-login-oca": 910,
	"./users/user-sso-login-oca.js": 910,
	"./users/user-sso-login.js": 446,
	"./widget/styles.module.scss": 246,
	"./widget/widget-facebook": 911,
	"./widget/widget-facebook-mall": 912,
	"./widget/widget-facebook-mall.js": 912,
	"./widget/widget-facebook.js": 911,
	"./widget/widget-weather": 913,
	"./widget/widget-weather.js": 913,
	"./widget/widget-wine": 914,
	"./widget/widget-wine.js": 914
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 861;


//////////////////
// WEBPACK FOOTER
// ./src/blocks ^\.\/.*$
// module id = 861
// module chunks = 0